import { FC } from 'react';
import { BpWrapper } from '@src/core/BpWrapper';
import { ISidebarMenuProps } from './models';
import { SidebarMenuDesktop } from './SidebarMenu@desktop';

export type { ISidebarMenuItem, ISidebarMenuProps } from './models';

export const SidebarMenu: FC<ISidebarMenuProps> = (props) =>
  BpWrapper<ISidebarMenuProps>(
    {
      DESKTOP: SidebarMenuDesktop,
    },
    props,
  );
